export const ApiRoutes = {
  reviewIntervals: 'v1/words/review/intervals',
  reviewDueCount: 'v1/words/review/due-count',
  reviewDueWords: 'v1/words/review/due',
  reviewWorkouts: 'v1/words/review/workouts',
  reviewWorkoutStatistics: 'v1/words/review/workouts/statistics',
  finishReviewWorkout: (workoutId: number) =>
    `v1/words/review/workouts/${workoutId}/finish`,
  wordReview: (wordId: number) => `v1/words/${wordId}/review`,
  postUser: 'v1/users',
  getWhoAmI: 'v1/users/who-am-i',
  patchStartRestoration: 'v1/users/start-password-restorarion',
  patchFinishRestoration: 'v1/users/finish-password-restorarion',
  postUserReport: 'v1/users/reports',
  patchChangePassword: 'v1/users/change-password',
  patchUpdateUserName: 'v1/users/update-name',
  userApiKeys: 'v1/users/api-keys',
  userApiKey: (id: number) => `v1/users/api-keys/${id}`,

  postLogin: 'v1/auth/login',
  getActivate: 'v1/auth/activate',
  getRefresh: 'v1/auth/refresh',
  getSignout: 'v1/auth/signout',
  postGoogleAuth: 'v1/auth/google',

  postDictionary: 'v1/dictionaries',
  putDictionary: (id: number) => `v1/dictionaries/${id}`,
  getPublicDictionary: (id: number) => `v1/dictionaries/${id}/public`,
  patchDictionaryPublicStatus: (id: number) => `v1/dictionaries/${id}/public`,
  patchDictionarySettings: (id: number) => `v1/dictionaries/${id}/settings`,
  getDictionaries: 'v1/dictionaries',
  deleteDictionary: (id: number) => `v1/dictionaries/${id}`,
  dictionaryShares: (id: number) => `v1/dictionaries/${id}/shares`,
  dictionaryShare: (id: number, shareId: number) =>
    `v1/dictionaries/${id}/shares/${shareId}`,
  leaveDictionaryShare: (id: number) => `v1/dictionaries/${id}/shares/me`,

  getLanguages: 'v1/languages',

  getDictionaryWords: (dictionaryId: number) =>
    `v1/words/dictionary/${dictionaryId}`,
  postWord: 'v1/words',
  postBatchWords: 'v1/words/batch',
  deleteManyWords: 'v1/words',
  updateWord: (id: number) => `v1/words/${id}`,
  updateWordsTrainingLevel: 'v1/words/trainingLevel',
  updateWordTimesOfUsage: 'v1/words/timesOfUsage',
  updateWordsDictionary: 'v1/words/dictionary-change',
  getOxfordWord: 'v1/words/oxford',
  getWord: (id: number) => `v1/words/${id}`,
  wordDescription: (wordId: number) => `v1/words/${wordId}/description`,
  publicWordDescription: (wordId: number) =>
    `v1/words/${wordId}/description/public`,
  wordSuggestions: 'v1/words/suggestions',
  wordRelations: (wordId: number) => `v1/words/${wordId}/relations`,
  wordRelation: (wordId: number, relationId: number) =>
    `v1/words/${wordId}/relations/${relationId}`,
  // Word Usage Examples
  postWordUsageExample: 'v1/word-usage-examples',
  getWordUsageExamples: (wordId: number) =>
    `v1/word-usage-examples/word/${wordId}`,
  getPublicWordUsageExamples: (wordId: number) =>
    `v1/word-usage-examples/word/${wordId}/public`,
  updateWordUsageExample: (id: number) => `v1/word-usage-examples/${id}`,
  deleteManyWordUsageExamples: (wordId: number) =>
    `v1/word-usage-examples/word/${wordId}`,
  // Word Forms
  postWordForm: 'v1/word-forms',
  getWordForms: (wordId: number) => `v1/word-forms/word/${wordId}`,
  getPublicWordForms: (wordId: number) => `v1/word-forms/word/${wordId}/public`,
  updateWordForm: (id: number) => `v1/word-forms/${id}`,
  deleteManyWordForms: (wordId: number) => `v1/word-forms/word/${wordId}`,
  // Header Slides
  getAllMySlides: 'v1/header-slides/all-my',
  headerSlides: 'v1/header-slides',
  updateSlide: (id: number) => `v1/header-slides/${id}`,
  // CV
  downloadCV: 'v1/pdf/cv',
  postCV: 'v1/cv',
}

export const todosApiRoutes = {
  post: 'v1/todos',
  postNextTask: 'v1/todos/next-repeating-todo',
  claimNotifications: 'v1/todos/notifications/claim',
  get: 'v1/todos',
  delete: 'v1/todos',
  deleteOneRepeatingTask: (id: number) => `v1/todos/${id}/one-repeating-task`,
  update: (id: number) => `v1/todos/${id}`,
  updateStatus: (id: number) => `v1/todos/${id}/status`,
  updateOrder: (id: number) => `v1/todos/${id}/order`,
}

export const todoListApiRoutes = {
  post: 'v1/todo-list-items',
  get: (todoId: number) => `v1/todo-list-items/todo/${todoId}`,
  delete: (todoId: number) => `v1/todo-list-items/todo/${todoId}`,
  deleteOneRepeatingSubtask: (todoId: number, subtaskId: number) =>
    `v1/todo-list-items/${todoId}/one-repeating-subtask/${subtaskId}`,
  update: (id: number) => `v1/todo-list-items/${id}`,
  updateOrder: (id: number) => `v1/todo-list-items/${id}/order`,
}

export const wordStuffApiRoutes = {
  translate: 'v1/word-stuff/translate',
}

export const wordPracticeSentencesApiRoutes = {
  post: 'v1/word-practice-sentences',
  get: (wordId: number) => `v1/word-practice-sentences/word/${wordId}`,
  reviewQueue: 'v1/word-practice-sentences/review',
  put: (id: number) => `v1/word-practice-sentences/${id}`,
  review: (id: number) => `v1/word-practice-sentences/${id}/review`,
  patchOrder: (id: number) => `v1/word-practice-sentences/${id}/order`,
  delete: (wordId: number) => `v1/word-practice-sentences/word/${wordId}`,
}

export const currenciesApiRoutes = {
  get: 'v1/currencies',
  post: 'v1/currencies',
  update: (id: string) => `v1/currencies/${id}`,
  setDefault: (id: string) => `v1/currencies/${id}/default`,
  delete: (id: string) => `v1/currencies/${id}`,
}

export const financeCategoriesApiRoutes = {
  get: 'v1/finance-categories',
  post: 'v1/finance-categories',
  update: (id: string) => `v1/finance-categories/${id}`,
  delete: (id: string) => `v1/finance-categories/${id}`,
}

export const financeAccountsApiRoutes = {
  get: 'v1/finance-accounts',
  post: 'v1/finance-accounts',
  update: (id: string) => `v1/finance-accounts/${id}`,
  delete: (id: string) => `v1/finance-accounts/${id}`,
}

export const financeTransactionsApiRoutes = {
  get: (accountId: string) =>
    `v1/finance-accounts/${accountId}/transactions`,
  post: (accountId: string) =>
    `v1/finance-accounts/${accountId}/transactions`,
  summary: (accountId: string) =>
    `v1/finance-accounts/${accountId}/summary`,
  preview: (accountId: string) =>
    `v1/finance-accounts/${accountId}/reconciliations/preview`,
  reconcile: (accountId: string) =>
    `v1/finance-accounts/${accountId}/reconciliations`,
  update: (id: string) => `v1/finance-transactions/${id}`,
  delete: (id: string) => `v1/finance-transactions/${id}`,
}

export const debtsApiRoutes = {
  get: 'v1/debts',
  post: 'v1/debts',
  getOne: (id: string) => `v1/debts/${id}`,
  update: (id: string) => `v1/debts/${id}`,
  delete: (id: string) => `v1/debts/${id}`,
  assign: (id: string) => `v1/debts/${id}/assign`,
  share: (id: string) => `v1/debts/${id}/share`,
  unshare: (id: string) => `v1/debts/${id}/share`,
  returns: (debtId: string) => `v1/debts/${debtId}/returns`,
  updateReturn: (debtId: string, returnId: string) =>
    `v1/debts/${debtId}/returns/${returnId}`,
  deleteReturn: (debtId: string, returnId: string) =>
    `v1/debts/${debtId}/returns/${returnId}`,
}

export const publicDebtApiRoutes = {
  verify: (token: string) => `v1/public/debts/${token}/verify`,
}

export const sharedTodoApiRoutes = {
  config: (todoId: number) => `v1/todos/${todoId}/share`,
  passwords: (todoId: number) => `v1/todos/${todoId}/share/passwords`,
  password: (todoId: number, passwordId: string) =>
    `v1/todos/${todoId}/share/passwords/${passwordId}`,
}

export const publicSharedTodoApiRoutes = {
  verify: (token: string) => `v1/public/shared-todos/${token}/verify`,
  get: (token: string) => `v1/public/shared-todos/${token}`,
  meta: (token: string) => `v1/public/shared-todos/${token}/meta`,
  subtasks: (token: string) => `v1/public/shared-todos/${token}/subtasks`,
  subtask: (token: string, subtaskId: number) =>
    `v1/public/shared-todos/${token}/subtasks/${subtaskId}`,
}

export const dictionaryFocusWordsApiRoutes = {
  post: 'v1/dictionary-focus-words',
  get: 'v1/dictionary-focus-words',
  put: (id: number) => `v1/dictionary-focus-words/${id}`,
  delete: (id: number) => `v1/dictionary-focus-words/${id}`,
}

export const materialApiRoutes = {
  post: 'v1/materials',
  get: 'v1/materials',
  getOne: (id: string) => `v1/materials/${id}`,
  update: (id: string) => `v1/materials/${id}`,
  delete: (id: string) => `v1/materials/${id}`,
  getShared: (token: string) => `v1/materials/shared/${token}`,
  uploadImage: 'v1/materials/upload-image',
  deleteImage: 'v1/materials/image',
}

export const courseApiRoutes = {
  post: 'v1/courses',
  get: 'v1/courses',
  getOne: (id: string) => `v1/courses/${id}`,
  update: (id: string) => `v1/courses/${id}`,
  delete: (id: string) => `v1/courses/${id}`,
  getShared: (token: string) => `v1/courses/shared/${token}`,
  sections: (id: string) => `v1/courses/${id}/sections`,
  section: (id: string, sectionId: string) =>
    `v1/courses/${id}/sections/${sectionId}`,
  sectionOrder: (id: string, sectionId: string) =>
    `v1/courses/${id}/sections/${sectionId}/order`,
  lessons: (id: string, sectionId: string) =>
    `v1/courses/${id}/sections/${sectionId}/lessons`,
  lessonOrder: (id: string, sectionId: string, lessonId: string) =>
    `v1/courses/${id}/sections/${sectionId}/lessons/${lessonId}/order`,
  lesson: (id: string, sectionId: string, lessonId: string) =>
    `v1/courses/${id}/sections/${sectionId}/lessons/${lessonId}`,
  progress: (id: string) => `v1/courses/${id}/progress`,
  lessonComplete: (id: string, lessonId: string) =>
    `v1/courses/${id}/lessons/${lessonId}/complete`,
}

export const imagesApiRoutes = {
  get: 'v1/images',
  upload: 'v1/images/upload',
  getOne: (id: string) => `v1/images/${id}`,
  delete: (id: string) => `v1/images/${id}`,
}
